import React from 'react'

const Error404 = () => {
  return (
    <div>Error</div>
  )
}

export default Error404